const fragment = window.location.hash;
const queryParams = fragment.split('?')[1];
const params = new URLSearchParams(queryParams);
const camp = params.get("camp");
const rcid = params.get("rcid");


const min = 10000;
  const max = 99999;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

  const sessionTime = Date.now();
  const sessionId = sessionTime + "" + randomNumber;
  if(!sessionStorage.getItem("sessionId")){
    sessionStorage.setItem("sessionId", sessionId);
  }

  export const getHeaders = () => {
    const headers = {
    "Username": "web",
    "Password": "web",
    "Language": "fr",
    "Appversion": 1.4,
    "Reqfrom": "app",
    "Servicefor": "mtngc"
}

    if(camp){
        sessionStorage.setItem("camp",camp)
    }
    if(rcid){
        sessionStorage.setItem("rcid",rcid)
    }

    const updatedHeaders = { ...headers };
    updatedHeaders["w_req_url"] = window.location.href;
    updatedHeaders["camp"] = camp || sessionStorage.getItem("camp") || "";
    updatedHeaders["rcid"] = rcid || sessionStorage.getItem("rcid") || "";
    updatedHeaders["flow"] = localStorage.getItem("mtype") || "";
    updatedHeaders["blocked"] = localStorage.getItem("blocked") || 0;
    updatedHeaders["breason"] = localStorage.getItem("breason") || "";
    updatedHeaders["sid"] =  sessionStorage.getItem("sessionId") || sessionId;
    updatedHeaders["msisdn"] = localStorage.getItem("msisdn") || ""

    return updatedHeaders;
};



const body = {
    wallpaper : {"msisdn":"701701701","mcc":"606","mnc":"00", "start_count" : "2", "end_count" : "12", "type" : 1},
    postman : {"msisdn":"701701701","mcc":"412","mnc":"01","calling_code":"","reqFrom":"postman"},
    dua : {"msisdn":"701701701","mcc":"412","mnc":"01","calling_code":"","duaId":"all"},
    salat : {"msisdn":"701701701","mcc":"412","mnc":"01","calling_code":"","duaId":"all"},
    quran : {"msisdn":"701701701","mcc":"412","mnc":"01","calling_code":"","duaId":"all"}
}
// const base = "https://portal.ibadatapp.com/api/";
const base = "https://is-apis.bngrenew.com/ongoing_orangeIC/api/"
// const base = "http://local.ibadatapp.com/api/"

// const base = "http://local.ibadatapp.com/api/index.php?endpoint="
// const redirect_url = "http://52.36.94.173/freesn/is/"
// const redirect_url = "http://52.36.94.173/mtngc/is/"
const redirect_url = "http://he.ibadat360.com/mtngc/"
// const redirect_url = "http://52.36.94.173/app_subscription/freesn/is/"

const elastic_base = "https://serviceusagesv1.bngrenew.com";

// App version for cache management
// To test version change: change this version number and reload the app
// Example: "1.4.1", "1.5.0", "2.0.0", etc.
export const APP_VERSION = "1.5.0";

export {  body,base,redirect_url, elastic_base  };